import { Img } from 'react-image';
import { Tooltip } from 'flowbite-react';
import { useCallback, useEffect, useState } from 'react';
import { generateCompanyLogoAvatarSrc } from 'src/utils/companyLogo';
import { MyCompanyType } from 'types';
import { Avatar } from '@mui/material';
import { stringAvatar } from 'shared-utils';

interface Props {
	companyDetail: MyCompanyType['company'];
	isFooter: boolean;
}

const AMCompanyDrawerHeaderFooter = ({ companyDetail, isFooter }: Props) => {
	const showCompanyAvatar = !isFooter;
	const [avatarImg, setAvatarImg] = useState<string>('');

	const generateAvatar = useCallback(async () => {
		const res = await generateCompanyLogoAvatarSrc(companyDetail?.logo || '', companyDetail?.url);
		setAvatarImg(res);
	}, [companyDetail?.logo, companyDetail?.url]);

	useEffect(() => {
		generateAvatar();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [companyDetail?.logo, companyDetail?.url]);

	const companyTitle = companyDetail.name;

	return (
		<>
			<div className="flex justify-center text-[#28293D] dark:text-white px-4 py-[10px]">
				<div className="flex w-full justify-between">
					{showCompanyAvatar ? (
						<div className="flex gap-4">
							<div className="flex justify-center items-center text-center min-w-[48px] min-h-[48px] max-w-[48px] max-h-[48px] rounded-full border border-[#F3F2F2]">
								<Avatar
									src={avatarImg}
									alt="companyLogo"
									sx={{ width: '38.4px', height: '38.4px', minWidth: '38.4px', minHeight: '38.4px' }}
								>
									{stringAvatar(companyDetail?.name.trim().toUpperCase() || '')}
								</Avatar>
							</div>
							<div>
								<div className="text-xl font-bold flex gap-3 items-center">
									{companyTitle.length > 20 ? (
										<Tooltip content={companyTitle} placement="top">
											{companyTitle.substring(0, 17)}...
										</Tooltip>
									) : (
										<>{companyTitle}</>
									)}
									{/* <IoShareSocialSharp
										size={18}
										className="cursor-pointer text-[#6698FA] hover:text-[#4b6fb6] md:hidden"
										onClick={() => {}}
									/> */}
								</div>
								<div
									onClick={() => window.open(`${companyDetail.url}`, '_blank')}
									className="flex cursor-pointer items-center gap-2 text-base font-medium text-[#6698FA] dark:text-inherit"
								>
									<span className="hover:underline">
										{companyDetail.name.length > 20 ? (
											<Tooltip content={companyDetail.name} placement="top">
												{companyDetail.name.length > 20
													? `${companyDetail.name.substring(0, 19)} ...`
													: `${companyDetail.name}`}
											</Tooltip>
										) : (
											<>
												{companyDetail.name.length > 20
													? `${companyDetail.name.substring(0, 19)} ...`
													: `${companyDetail.name}`}
											</>
										)}
									</span>
									<span>
										<Img
											loading="lazy"
											className=""
											src="/assets/externalLinkIcon.svg"
											alt="externalLinkIcon"
											width="16"
											height="16"
										/>
									</span>
								</div>
							</div>
						</div>
					) : null}
				</div>
			</div>
		</>
	);
};

export default AMCompanyDrawerHeaderFooter;
